<template>
  <v-container fluid>
    <v-combobox
      class="mx-2"
      v-model="filters"
      :filter="filter"
      :items="severities"
      label="Filter Label Severities"
      hide-selected
      hide-details
      multiple
      small-chips
      @change="filterAnnotes"
    >
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="`${item.color}`"
          :input-value="selected"
          label
          :text-color="`${item.textColor}`"
          small
        >
          <span class="pr-2">
            {{ item.text }}
          </span>
          <v-icon
            small
            @click="parent.selectItem(item)"
          >close</v-icon>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-chip
          :color="`${item.color}`"
          label
          small
          :text-color="`${item.textColor}`"
        >
          {{ item.text }}
        </v-chip>
      </template>
    </v-combobox>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { severityColorPicker } from '@methods/helpers';

export default {
  name: 'SeverityComboBox',
  data: () => ({
    filters: [],
    severities: [
      { value: 'None', text: 'None', color: 'green' },
      { value: 'Low', text: 'Low', color: 'blue' },
      { value: 'Medium', text: 'Medium', color: 'yellow' },
      { value: 'High', text: 'High', color: 'red' },
      { value: 'Critical', text: 'Critical', color: 'black' },
    ],
    defaultFilters: [
      { value: 'None', text: 'None', color: 'green' },
      { value: 'Low', text: 'Low', color: 'blue' },
      { value: 'Medium', text: 'Medium', color: 'yellow' },
      { value: 'High', text: 'High', color: 'red' },
      { value: 'Critical', text: 'Critical', color: 'black' },
    ],
  }),
  computed: {
    ...mapGetters(['currentAnnotations', 'companyHas', 'currentImage']),
  },
  methods: {
    ...mapActions(['setLabelFilter']),
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : '');

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1;
    },
    filterAnnotes(severityList) {
      const classOnlyLabels = severityList.map((c) => c.value);
      this.setLabelFilter(classOnlyLabels);
    },
    setDefaults() {
      if (this.companyHas('defaultSeverity')) {
        this.filters = [...this.defaultFilters];
        this.filterAnnotes(this.defaultFilters);
      } else {
        this.filters = [];
        this.filterAnnotes([]);
        this.defaultFilters.forEach((filter, index) => {
          const colorData = severityColorPicker(filter.value);
          this.defaultFilters[index].color = colorData.color;
          this.defaultFilters[index].textColor = colorData.text;
        });

        this.severities = [...this.defaultFilters];
      }
    },
  },
  mounted() {
    this.setDefaults();
  },
  watch: {
    // TODO: Find what this is for because it causes bugs on the anno filter
    // currentAnnotations() {
    //   this.setDefaults();
    // },
    currentImage() {
      this.setDefaults();
    },
  },
};
</script>
